import { ContentContainer } from "../../../lib/src/components/content/ContentContainer";
import { faCheck, faCircleNotch, faWarning } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumbs } from "../../../lib/src/components/content/Breadcrumbs";
import { PageHeader } from "../../../lib/src/components/content/PageHeader";
import { Card } from "@hostingbv/lib/src/components/Card";
import { FC, useEffect, useState } from "react";
import { Button } from "../../../lib/src/components/form/Button";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Paragraph } from "../../../lib/src/components/Paragraph";

export const Settings: FC = () => {
  return (
    <ContentContainer size={'sm'}>
      <Breadcrumbs crumbs={[
      ]} currentPage={"Settings"} />
      <PageHeader>Settings</PageHeader>
      <ResetPasswordCard />
      <MfaCard />
    </ContentContainer>
  )
}

const ResetPasswordCard: FC = () => {
  const { partnerClient } = useApiClient(config)
  return (
    <Card title={"Reset Password"}>
      <Paragraph>
        Want to reset your password? Click the button below to set a new one. It is recommended to regularly change your password.
      </Paragraph>
      <Button text={"Reset Password"} type={'primary'} size={'sm'} onClick={async () => {
        await partnerClient.resetPassword()
        window.location.reload();
      }} />
    </Card>
  )
}

const MfaCard: FC = () => {
  const { partnerClient } = useApiClient(config)
  const [state, setState] = useState<boolean | null>(null);

  useEffect(() => {
    partnerClient.getMFAStatus().then((enabled) => {
      setState(enabled)
    })
  })

  const enableMfa = async () => {
    await partnerClient.enableMFA()
    window.location.reload()
  };

  const resetMfa = async () => {
    await partnerClient.resetMFA()
    window.location.reload()
  };

  return (
    <Card title={"Multi Factor Authentication"}>
      <Paragraph>
        Multi Factor Authentication (MFA) adds an extra layer of security to your account. Once enabled, you will be required to enter a code from your authenticator app in addition to your password when logging in.
      </Paragraph>
      <MFAStatus status={state} />
      {!state ? <div className={"my-2"}>
        <Button text={"Set up MFA"} type={'primary'} size={'sm'} onClick={enableMfa} />
      </div> : <div className={"my-2"}>
        <Button text={"Reset MFA"} type={'primary'} size={'sm'} onClick={resetMfa} />
      </div>}
    </Card>
  )

}

const MFAStatus: FC<{ status: boolean | null }> = props => {
  let loadingText;
  let mfaIcon;
  let iconBgColor;
  let iconTextColor;
  if (props.status === null) {
    loadingText = 'Verifying...'
    mfaIcon = faCircleNotch;
    iconBgColor = "bg-gray-100 animate-spin"
    iconTextColor = "text-gray-400"
  } else if (!props.status) {
    loadingText = 'Multifactor Authentication is NOT Enabled'
    mfaIcon = faWarning;
    iconBgColor = "bg-red-100"
    iconTextColor = "text-red-400"
  } else {
    loadingText = 'Multifactor Authentication Enabled'
    mfaIcon = faCheck;
    iconBgColor = "bg-emerald-100"
    iconTextColor = "text-emerald-500"
  }
  return <div className={"flex items-center border border-slate-200 rounded-lg p-4"}>
    <div className={`h-8 w-8 rounded-full ${iconBgColor} flex items-center justify-center`}>
      <FontAwesomeIcon icon={mfaIcon} className={`${iconTextColor}`} />
    </div>
    <div className={"flex-1 mx-3"}>
      <h2 className={"text-slate-500 text-sm"}><span>{loadingText}</span></h2>
    </div>
  </div>
}
